// File picker strings (auto-merged by lib/i18n.ts).
export const en = {
  'ds.filefield.replace': 'Replace',
  'ds.filefield.remove': 'Remove file',
  'ds.filefield.click_to_upload': 'Click to upload',
  'ds.filefield.or_drag_drop': 'or drag & drop',
}

export const zhTW = {
  'ds.filefield.replace': '更換',
  'ds.filefield.remove': '移除檔案',
  'ds.filefield.click_to_upload': '點擊上傳',
  'ds.filefield.or_drag_drop': '或拖放檔案',
}
